import { render, staticRenderFns } from "./color-suggestion.vue?vue&type=template&id=962e457c"
import script from "./color-suggestion.vue?vue&type=script&lang=js"
export * from "./color-suggestion.vue?vue&type=script&lang=js"
import style0 from "./color-suggestion.vue?vue&type=style&index=0&id=962e457c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports